import kebabCase from 'lodash/kebabCase';

const EMOJI_REGEX =
    /\u{1F3F4}[\u{E0020}-\u{E007E}]+\u{E007F}|[\u{1F1E6}-\u{1F1FF}]{2}|[#*0-9]\u{FE0F}?\u{20E3}|\p{Extended_Pictographic}\p{Emoji_Modifier}?\u{FE0F}?(?:\u{200D}\p{Extended_Pictographic}\p{Emoji_Modifier}?\u{FE0F}?)*/gu;
/**
 * Take the given string and returns a slugified version of the string.
 * Emojis are stripped from the input while preserving characters from other writing systems
 * (e.g., Cyrillic, Japanese kanji, Chinese, Arabic, etc.).
 * @param  value The value to slugify.
 * @return The slugified value
 */
export const slugify = (value: string): string => {
    const valueWithoutEmojis = value.replace(EMOJI_REGEX, '');

    const firstLetter = valueWithoutEmojis.charAt(0);
    const lastLetter = valueWithoutEmojis.charAt(value.length - 1);
    const newValue = kebabCase(valueWithoutEmojis.toLowerCase());

    /**
     * Lodash's kebabCase function doesn't allow trailing dashes and spaces.
     * In some case, we might want to keep this trailing dash (when someone is typing for instance).
     */
    if (newValue !== '' && firstLetter !== '-' && (lastLetter === '-' || lastLetter === ' ')) {
        return `${newValue}-`;
    }

    return newValue;
};
